<ng-container
  *ngIf="{
    product: product$ | async,
    mainContent: mainContent$ | async,
  } as content"
>
  <div *ngIf="content.product" class="container-simple-gallery">
    <div class="main-image type-{{ content.mainContent?.type }}">
      @if (content.mainContent?.type === GALLERY_MEDIA_TYPE.VIDEO) {
        <iframe-viewer [iframe]="getIframeVideo(content.mainContent?.content!)"></iframe-viewer>
      }

      @if (content.mainContent?.type === GALLERY_MEDIA_TYPE.IMAGES) {
        @if (content?.mainContent?.content?.superZoom?.url || content?.mainContent?.content?.zoom?.url) {
          <div class="main-image type-{{ content.mainContent?.type }}" style="position: relative;">
            <img [src]="content?.mainContent?.content?.superZoom?.url || content?.mainContent?.content?.zoom?.url" alt=""
              (click)="openModal(content.mainContent)" (keyup.enter)="openModal(content.mainContent)" [attr.tabindex]="0"
              class="zoom-in" />
            <div class="image-overlay" *ngIf="content.product?.representativeImage?.toLowerCase() === 'yes'">
              {{ 'productDetails.representativeImage' | cxTranslate }}
            </div>
          </div>
        } @else {
          <cx-media [container]="" tabindex="0" [format]="'superZoom'"></cx-media>
        }
      }

      @if (content.mainContent?.type === GALLERY_MEDIA_TYPE.IMAGE_360) {
        <magic-360 [image360]="content.mainContent?.content!"></magic-360>
      }
    </div>

    <div class="simple-thumbs">
      <simple-thumbs></simple-thumbs>
    </div>
  </div>
</ng-container>
